import React from "react";
import { Routes, Route } from "react-router-dom";

import AppDownload from "./AppDownload";

const AppLinksRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/app-download" element={<AppDownload />} />
      <Route path="/*" element={<AppDownload />} />
    </Routes>
  );
};
export default AppLinksRoutes;
